// import $ from 'jquery';
import plugin from '../lib';
export const ELEMENT_SELECTOR = '[data-trigger-event]';
export const PLUGIN_NAME = 'triggerEvent';

import TriggerEvent from './plugin';

plugin(PLUGIN_NAME, TriggerEvent);

$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    $(element)[PLUGIN_NAME]();
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__trigger-event/index.js